require('intersection-observer');
import viewport from "./viewport"
import detectIt from 'detect-it';

export default function () {


    let productFixedRow  = document.getElementsByClassName('product-detail-mobile-fixed')[0];

    if(productFixedRow) {
        let productDetail = document.getElementsByClassName('product-detail')[0];
        let productDetailBottom = productDetail.offsetTop + productDetail.clientHeight - viewport().height;

        let pageFooter = document.getElementsByClassName('page-footer')[0];
        let pageFooterTop = pageFooter.offsetTop - viewport().height;

        window.addEventListener('scroll', function () {
            let windTop = window.scrollY;

            if (windTop > productDetailBottom && windTop < pageFooterTop) {
                productFixedRow.classList.add('is-visible');
            }
            else{
                productFixedRow.classList.remove('is-visible');
            }

        });
    }


    let autoPlayVideo = document.getElementsByClassName('iframe-video')[0];

    if(autoPlayVideo) {
        let videoTop = autoPlayVideo.offsetTop - autoPlayVideo.clientHeight/2;
        let videoFrame = autoPlayVideo.getElementsByTagName('iframe')[0];
        let videoPlayFl = false;

        window.addEventListener('scroll', function () {
            let windTop = window.scrollY;
            if (windTop > videoTop && !videoPlayFl) {
                let frameSrc = videoFrame.src;
                videoFrame.src = frameSrc+ '?autoplay=1';
                videoPlayFl = true;
            }
        });
    }

//Only Use the IntersectionObserver if it is supported
    if (IntersectionObserver && detectIt.hasTouch) {
        //When the element is visible on the viewport,
        //add the animated class so it creates the animation.
        let callback = function(entries) {
            entries.forEach(entry => {
                //if the element is visible, add the animated class
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                }
                else{
                    entry.target.classList.remove('in-view');
                }
            });
        }
        //Create the observer
        let observer = new IntersectionObserver(callback, {
            root: null,
            threshold: 0.3
        });

        //Get and observe all the items with the item class
        let items = document.querySelectorAll('.main-celebrities__item');
        items.forEach((item) => {
            item.classList.remove('in-view');
            observer.observe(item);
        });
    }

};
